module.exports = __webpack_public_path__ + "img/bg_seat.deb4baa2.jpg";